import { render, staticRenderFns } from "./ChaldalTerms.vue?vue&type=template&id=6dc18276&scoped=true&"
import script from "./ChaldalTerms.vue?vue&type=script&lang=js&"
export * from "./ChaldalTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc18276",
  null
  
)

export default component.exports